// extracted by mini-css-extract-plugin
export default {"links":"header_register_links__bPS0v","navLinks":"header_register_navLinks__5rOzC"};